module.exports = __webpack_public_path__ + "img/window-restore.4717fe6a.svg";